import { Button, Stack } from "@mui/material";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
import { useState } from "react";
import { CustomTextView } from "./CustomTextView";
import { COLOR_BLACK } from "../../data/colors/Colors";
import useWindowDimensions from "../../core/utils/UseWindowDimensions";

export function ChooseStartEndDateView({
  onClicked,
  title,
}: {
  onClicked: (startDate: Date | null, endDate?: Date | null) => void;
  title: string;
}) {
  // Start at the first day of the current month, 00:00
  const [startDate, setStartDate] = useState<Date | null>(
    new Date(new Date().getFullYear(), new Date().getMonth(), 1)
  );
  // End at now
  const [endDate, setEndDate] = useState<Date | null>(new Date());

  const { width } = useWindowDimensions();
  const isMobile = width < 900;

  return (
    <Stack
      spacing={1}
      direction={isMobile ? "column" : "row"}
      alignItems={"center"}
      width={"100%"}
      pl={3}
      pr={3}
    >
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <DateTimePicker
          label="Start Date"
          slotProps={{
            textField: {
              InputProps: {
                sx: { borderRadius: 22 },
              },
            },
          }}
          sx={{ width: isMobile ? "100%" : undefined }}
          value={dayjs(startDate?.toISOString())}
          onChange={(d) => {
            try {
              const date = d?.toDate();
              if (date) {
                setStartDate(date);
              }
            } catch (e) {
              setStartDate(new Date());
            }
          }}
        />
        <DateTimePicker
          label="End Date"
          slotProps={{
            textField: {
              InputProps: {
                sx: { borderRadius: 22 },
              },
            },
          }}
          sx={{ width: isMobile ? "100%" : undefined }}
          value={dayjs(endDate?.toISOString())}
          onChange={(d) => {
            try {
              const date = d?.toDate();
              if (date) {
                setEndDate(date);
              }
            } catch (e) {
              setEndDate(new Date());
            }
          }}
        />
      </LocalizationProvider>
      <Button
        onClick={() => {
          onClicked(startDate, endDate);
        }}
        variant="outlined"
        sx={{
          borderRadius: 22,
          borderColor: COLOR_BLACK,
          p: 1.5,
          textTransform: "none",
        }}
        fullWidth={isMobile}
      >
        <CustomTextView text={title} />
      </Button>
    </Stack>
  );
}
